<!-- @format -->

<template>
	<div class="home mgs-centered-box">
		<img class="home-logo" alt="MGS logo" src="../assets/mgs.svg" />

		<p v-if="!loggedIn">
			To use My Golf Snapshot you will either need to
			<router-link to="/login">Login</router-link> or
			<router-link to="/register">Register</router-link>
		</p>
	</div>
</template>

<script>
/** @format */
import {authComputed} from './../store/helpers.js';

export default {
	computed: {
		...authComputed
	}
};
</script>
<style lang="scss" scoped>
.home-logo{
	width: 100%;
	padding: 20px;
	max-width:500px;
	position:relative;
	&:before{
		content:'';

	}
}

</style>
